import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: '"Cairo", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600 },
  },
  palette: {
    primary: {
      main: '#000000', // Dark Teal (Mobile App Primary)
      contrastText: '#fff',
    },
    primaryGradient: 'linear-gradient(90deg, #960018 0%, #6d0012 100%)',
    secondary: {
      main: '#0f766e', // Teal Accent
      contrastText: '#fff',
    },
    background: {
      default: '#F8FAFC', // Light Gray/Blueish White (Mobile App Background)
      paper: '#FFFFFF',
    },
    text: {
      primary: '#000000', // Mobile App Heading Color
      secondary: '#666666', // Mobile App Secondary Text
    },
    error: {
      main: '#ef4444',
    },
    success: {
      main: '#22c55e',
      light: '#ECFDF5',
      dark: '#2e7d32',
    },
    warning: {
      main: '#f59e0b',
      light: '#FFFBEB',
    },
    info: {
      main: '#0288D1',
    },
    custom: {
      border: '#E2E8F0',
      primaryLight: '#E0F7FA',
      primaryDark: '#006064',
      secondaryLight: '#e0f2f1',
      secondaryDark: '#00695c',
      purple: '#7B1FA2',
      whatsapp: '#25D366',
      white: '#FFFFFF',
      black: '#000000',
      transparentWhite: 'rgba(255, 255, 255, 0.2)',
      transparentWhiteStrong: 'rgba(255, 255, 255, 0.6)',
    },
  },
  shape: {
    borderRadius: 20, // Match mobile app rounded corners (20px)
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12, // Mobile buttons are often 12px
          textTransform: 'none',
          padding: '12px 24px',
          boxShadow: 'none',
          fontWeight: 700,
          '&:hover': {
            boxShadow: '0 4px 12px rgba(2, 55, 68, 0.2)',
          },
        },
        containedPrimary: {
          background: '#023744',
          '&:hover': {
            background: '#01262f',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 8px 24px rgba(2, 55, 68, 0.08)', // Soft colored shadow like mobile
          border: '1px solid #eaeaea',
          transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 32px rgba(2, 55, 68, 0.15)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: '#023744',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 16,
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
});

export default theme;
